module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Medium.628fe3b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Medium.woff2
// module id = ta2P
// module chunks = 0